import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { Snackbar } from '@scramble/ui';
import { getMessage } from '@/helpers/utils';
import { investingService } from '../../services/investingService';

export const useSetAllocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      investingService
        .setAllocation(payload)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            queryClient.setQueryData(
              [QUERY_KEYS.investing.pre_allocate_info],
              data,
            );
            return { data, success: true };
          }

          if (status === 422) {
            Snackbar({ type: 'danger', text: getMessage(data) });
          }

          if (status === 406) {
            Snackbar({ type: 'danger', text: getMessage(data) });
          }

          throw new Error(getMessage(data?.message));
        })
        .catch(e => {
          return { success: false, error: e.message };
        }),
  });
};
